import React from "react";

import Highlighter from "react-highlight-words";

import { formatDateForDisplay, formatStatusLabel } from "../../../utils/helpers";
import {
  formatPickupItemsCell,
  formatPickupLabelsCell,
  getPickupCategoryLabel,
  getPickupStatusBadgeClass,
  getPickupStatusDisplayLabel,
} from "./utils";

const displayOrDash = (value) => {
  if (value == null) return "-";
  const text = String(value).trim();
  return text || "-";
};

const formatPickupTableDate = (value) => {
  if (value == null || String(value).trim() === "") return "-";
  const formatted = formatDateForDisplay(value, "DD MMM YYYY");
  return formatted || "-";
};

export default function RequestTableRow({
  row,
  columns,
  onRowClick,
  actionMap,
  onSpInstructionClick = () => {},
  onDeleteClick = () => {},
  onCreateEditClick = () => {},
  onPrintLabelClick = () => {},
  onDownloadLabelClick = () => {},
  onViewOrderSummaryClick = () => {},
  highlightWords = [],
}) {
  return (
    <tr onClick={() => {
      if (onRowClick) {
        onRowClick({ open: true, data: row });
      }
    }}
    >
      {columns.map((column, idx) => {
        let tableCellClassName = `${column.name === "Order ID" ? "OrderID " : ""}${column.className || ""}`;
        let node = displayOrDash(row[column.key]);
        if (column.key === "status") {
          if (row.pickup_order_id) {
            const label = getPickupStatusDisplayLabel(row.status, row.pickup_category);
            const badgeClass = getPickupStatusBadgeClass(row.status, row.pickup_category);
            node = (
              <span className={`RequestTableStatusBadge ${badgeClass}`}>
                {label}
              </span>
            );
          } else {
            node = formatStatusLabel(node);
            tableCellClassName = `${tableCellClassName} RequestTableStatusCell--${row[column.key]}`;
          }
        } else if (column.key === "items") {
          if (row.pickup_order_id) {
            node = formatPickupItemsCell(row);
          } else {
            node = `${row[column.key].length} item(s)`;
          }
        } else if (column.key === "total_labels") {
          node = formatPickupLabelsCell(row);
        } else if (column.key === "total_submissions") {
          const count = Array.isArray(row.submission_list) ? row.submission_list.length : 0;
          node = count > 0 ? String(count).padStart(2, "0") : "-";
        } else if (column.key === "order_date" || column.key === "pickup_date") {
          node = formatPickupTableDate(row[column.key]);
        } else if (column.cell) {
          node = React.cloneElement(column.cell, {
            row,
            actionMap,
            onCreateEditClick,
            onSpInstructionClick,
            onDeleteClick,
            onPrintLabelClick,
            onDownloadLabelClick,
            onViewOrderSummaryClick,
          });
        } else if (column.key === "pickup_category") {
          node = getPickupCategoryLabel(row[column.key]);
        } else if (column.key === "request_type") {
          const requestTypeLabels = { recurring: "Recurring", normal: "Normal" };
          node = requestTypeLabels[row[column.key]?.toLowerCase()] || "-";
        }

        if (column.name === "Order ID" && highlightWords.length > 0 && row[column.key]) {
          node = (
            <Highlighter
              highlightClassName="RequestTable__SearchHighlight"
              searchWords={highlightWords}
              autoEscape
              textToHighlight={String(row[column.key])}
            />
          );
        }

        return ((
          <td
            key={idx}
            className={tableCellClassName}
            onClick={(e) => {
              if (column.key === "action") {
                e.stopPropagation();
              }
            }}
          >
            {node}
          </td>
        ));
      })}
    </tr>
  );
}
